const keyboardDatePicker = {
  deadline: 'Prazo'
};

export default keyboardDatePicker;
